import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './TaxonomyLookupModalHeader.scss';

function TaxonomyLookupModalHeader({ close, opModel, totalHitCount }) {
  const modalTitle = opModel?.title || 'lookup';
  const closeLabel = `Close ${modalTitle} modal`;

  return (
    <div className="taxonomyLookupModal__header">
      <h3 className="rx-newmodal-title taxonomyLookupModal__header_title">
        {opModel.title}
        {!!totalHitCount && <span className="taxonomyLookupModal__header_badge">- {totalHitCount}</span>}
      </h3>
      <ButtonWithIcon
        data-e2e="taxonomyLookupModal-header-close"
        type="link"
        size="small"
        sprite="Close"
        className="u-els-margin-right-1o2"
        linkIconSize="xs"
        iconOnly
        aria-label={closeLabel}
        onClick={close}>
        {closeLabel}
      </ButtonWithIcon>
    </div>
  );
}

TaxonomyLookupModalHeader.propTypes = {
  close: PropTypes.func.isRequired,
  opModel: PropTypes.object,
  totalHitCount: PropTypes.number,
};

export default TaxonomyLookupModalHeader;
